'use client'

import { useState, useEffect } from 'react'
import Image from 'next/image'
import Modal from 'react-modal'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light'

const CatalogBlock = () => {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        Modal.setAppElement('#hivenext')
    }, [])

    const closeModal = () => {
        setIsOpen(false)
    }

    return (
        <>
            <div className="group block">
                <div className="w-full flex items-center md:justify-center mx-auto">
                    <div className="max-w-[175px] basis-1/2 md:basis-1/3">
                        <div className="w-[40px] h-[40px] text-xs text-white rounded-full bg-primary flex items-center justify-center mb-4">New!</div>

                        <button onClick={() => setIsOpen(true)} className="text-left"><h3 className="text-2xl text-dark font-extralight mb-4 hover:text-primary transition-colors">Explore Our Latest Catalog</h3></button>

                        <button onClick={() => setIsOpen(true)} className="text-2xs underline transition-colors hover:text-primary">View Issue 12</button>

                    </div>
                    <div className="basis-1/2 md:basis-1/3">
                        <button onClick={() => setIsOpen(true)}>
                            <Image
                                className=""
                                src="/images/catalog-12.png"
                                alt="Explore the hive Catalog"
                                width={600}
                                height={465}
                                quality={90}
                                sizes="450px"
                            />
                        </button>
                    </div>
                    <div className="hidden md:block max-w-[175px] basis-1/3">
                        <p className="text-left text-light text-xs">
                            Browse our catalog and explore a carefully curated assortment of the finest modern furniture and lighting from the world's most celebrated designers.
                        </p>
                    </div>
                </div>
            </div>

            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                contentLabel="hive Catalog"
                overlayClassName="z-[1055] fixed outline-0 top-0 bottom-0 left-0 right-0 bg-modal-overlay"
                className="fixed top-1/2 left-1/2 right-auto bottom-auto -mr-[50%] -translate-y-1/2 -translate-x-1/2 w-[calc(100%-60px)] max-w-5xl h-[70vh] max-h-[calc(100vh-60px)] rounded-sm shadow-2xl outline-none"
                bodyOpenClassName="ReactModal__Body--open"
                htmlOpenClassName="ReactModal__Html--open"
            >
                <button
                    type="button"
                    onClick={closeModal}
                    className="absolute -top-3 -right-3 w-8 h-8 flex items-center justify-center bg-white rounded-full shadow-lg text-dark hover:text-primary transition-colors z-10"
                    aria-label="Close catalog"
                >
                    <FontAwesomeIcon icon={faXmark} className="text-lg" />
                </button>

                <iframe
                    title="hive catalog issue 12"
                    allow="clipboard-write; autoplay; encrypted-media; fullscreen; picture-in-picture"
                    sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
                    allowFullScreen={true}
                    className="w-full h-full rounded-lg overflow-hidden"
                    src="https://e.issuu.com/embed.html?backgroundColor=%23FFFFFF&backgroundColorFullscreen=&d=hive_catalog_issue_12_b5ca753cd9fd48&hideIssuuLogo=true&hideShareButton=true&showOtherPublicationsAsSuggestions=true&themeMainColor=%23767676&themeSecondaryColor=%23ffffff&u=hivemodern.com"
                />
            </Modal>
        </>
    )
}

export default CatalogBlock
